import { getCookie } from '../components/common/cookie';

export const isWechat = () =>
  getCookie('padiWxId')?.length === 28 ||
  window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > 0;

export const isUnionId = (id) => id?.length === 28;